import { api } from "@/api";
import { threadStore } from "@/store/thread";
import { RawArtifact } from "@/types/artifact";
import { isAxiosError } from "axios";
import isEqual from "fast-deep-equal";
import useSWR from "swr";
import { userStore } from "../store/user";

export function useLatestArtifacts(threadId: string) {
  useSWR(
    ["get-artifacts", threadId],
    async () => {
      const res = await api.threads.getThreadArtifacts(threadId, {
        multi_version: true,
      });
      return res.data as RawArtifact;
    },
    {
      onSuccess(data) {
        const currentArtifacts = threadStore.rawArtifacts;

        if (!currentArtifacts || !isEqual(currentArtifacts, data)) {
          threadStore.set("rawArtifacts", data);
          threadStore.fetchThreadCredits(threadId);
          userStore.fetchUser();
        }
        threadStore.set("artifactsRequestStatus", "success");
      },
      onError(err) {
        if (isAxiosError(err) && err.response?.status === 404) {
          threadStore.set("rawArtifacts", null);
          threadStore.set("artifactsRequestStatus", "not_found");
        } else {
          threadStore.set("artifactsRequestStatus", "error");
        }
      },
      refreshInterval: 5000,
    }
  );
}
